import type { DomainFilterValue } from '../types';

export function parseDomainFilterParam(value: string | null): DomainFilterValue | undefined {
  if (!value || value === 'all') return 'all';
  if (value === 'you') return 'you';
  return value;
}

export function domainFilterToParam(value: DomainFilterValue): string | null {
  if (value === 'all') return null;
  return value;
}
